import styled, { css } from 'styled-components';

export const TimingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: ${props => (props.margin ? props.margin : 'auto')};
`;

export const TimingLabel = styled.div`
  color: ${props => props.theme.colors[props.color]};
  font-family: ${props => props.theme.fontSets[props.font]};
  font-size: ${props => (props.size ? `${props.size}em` : '15px')};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    font-size: ${props => (props.size ? `${props.size}em` : '12px')};
  };
  ${props => props.isMobile && css`
    font-size: 11px;
`};
`;



// WEBPACK FOOTER //
// ./src/components/TimeResults/Timing/styles.js